<script lang="ts">
import { Accordion, AccordionItem, Label, TabContent, TabPane } from "sveltestrap";
import { paramsService } from "../services";
import AppWraper from "../components/AppWraper.svelte";
import type { Param } from "../Model/Param";
import FilesList from "../components/FilesList.svelte";
import { REGISTERSCITATIONS, REGISTERSDETAINED, REGISTERSEXTERNALANTECEDENTS, REGISTERSINTOOUT, REGISTERSLOSTOBJECTS, REGISTERSUNIDENTIFIEDPERSON } from "../evironment";

let diligencesTypes: Param[];

loadTypes()

async function loadTypes() {
    
    diligencesTypes = await paramsService.findByType('diligencesTypes');

    diligencesTypes.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    diligencesTypes = diligencesTypes;
    
  }

</script>



<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Listados de Archivos</h3>
                    </div>
                </div>
            <div class="col-12 col-sm-3 mb-3">

            </div>
            {#if diligencesTypes}
                <Accordion>
                    {#each diligencesTypes as type}
                        <AccordionItem header={type.name}>
                            <FilesList contextId={type.id}/>
                        </AccordionItem>
                    {/each}
                    <AccordionItem header="Registro de entrada">
                        <FilesList contextId={REGISTERSINTOOUT}/>
                    </AccordionItem>
                    <AccordionItem header="Registro de Antecedentes Externos">
                        <FilesList contextId={REGISTERSEXTERNALANTECEDENTS}/>
                    </AccordionItem>
                    <AccordionItem header="Registro de Personas sin identificar">
                        <FilesList contextId={REGISTERSUNIDENTIFIEDPERSON}/>
                    </AccordionItem>
                    <AccordionItem header="Registro de Citaciones">
                        <FilesList contextId={REGISTERSCITATIONS}/>
                    </AccordionItem>
                    <AccordionItem header="Registro Detenidos">
                        <FilesList contextId={REGISTERSDETAINED}/>
                    </AccordionItem>
                    <AccordionItem header="Registro Objetos Perdidos">
                        <FilesList contextId={REGISTERSLOSTOBJECTS}/>
                    </AccordionItem>
                </Accordion>
            {/if}
        </div>
    </div>
</AppWraper>